/**
 * 群公告页纯逻辑（14.28；旧版 GroupAnnouncementPage 对应）。
 *
 * 协议实锤（func_group.go ChangeGroup）：发布/删除都走 group/change
 * Field=notice——Value 无 required 绑定，**空串即删除**（member_change 的
 * 「空串不写库」不适用本接口）；权限=管理员+（gm.Type!=0），成员只读；
 * 成功广播 32（Id=1 不落库）→ 快照缓存失效既有链找平他端。
 * 写链 14.26a changeGroup('notice', v) 已全备：成功本地 patch 快照零回读。
 */

/**
 * 发布钮可用：修剪后非空（旧版「请输入公告内容」守门）且与当前公告不同
 * （没改零请求——member_change 改昵称同口径）。
 */
export function canPublishNotice(current: string, draft: string): boolean {
  const v = draft.trim();
  return v !== '' && v !== current.trim();
}

/** 删除钮可见：当前已有公告（旧版同口径；空公告无可删） */
export function canDeleteNotice(current: string): boolean {
  return current.trim() !== '';
}

/**
 * 聊天页公告条的单行预览（21ah）。
 *
 * 公告是多行文本（公告页用 textarea 编辑），直接塞进单行会把换行渲染成空格、
 * 连续空白撑出一长条空档。这里先把所有空白折叠成单个空格再 trim，长度交给
 * CSS 的 ellipsis——按字符数截断在中英混排下很难看，而横幅宽度本来就随端变化。
 */
export function noticePreview(notice: string): string {
  return notice.replace(/\s+/g, ' ').trim();
}

/**
 * 聊天页要不要出公告条：群会话 + 公告非空。
 *
 * 私聊恒 false（`ComposerRestriction.notice` 在私聊是空串，这里再判一次会话域
 * 是防御——限制态 fail-open 时也不会在私聊里冒出一条群公告）。
 */
export function shouldShowNoticeBanner(conversationKey: string, notice: string): boolean {
  return conversationKey.startsWith('group:') && noticePreview(notice) !== '';
}
